<template>
    <div class="appLoadingWrapper d-flex flex-column justify-content-center h-100 w-100">
        <div class="w-100 text-center">
            <img src="../../assets/images/logo.svg" class="logo">
            <div class="mt-2">
                <loader></loader>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Loader from '@/tools/loaders/loader1'
export default {
    components:{
        Loader
    }
}
</script>

<style lang="scss" scoped>
.appLoadingWrapper{
    position: absolute;
    background-color: #222c3c;
}

.logo{
    width: 250px;
}
</style>



// WEBPACK FOOTER //
// Loading.vue?69f7fe33